import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MarketProductService } from '@serengeti/serengeti-market';
import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardMarketNewComponent')
@Component({
  selector: 'app-wizard-market-new',
  templateUrl: './wizard-market-new.component.html',
  styleUrls: ['./wizard-market-new.component.scss']
})
export class WizardMarketNewComponent implements OnInit, DashboardWidgetContent {

  activeProduct: any;
  products: any[];
  imageQueue = [] as any[];

  sanitizer: DomSanitizer;
  activeIndex = 0;

  constructor(
		sanitizer: DomSanitizer,
    private marketService: MarketProductService
  ) {
    this.sanitizer = sanitizer;
  }
  property(): boolean {
    return false;
  }
  configure(setting: any): void {
  }

  ngOnInit() {
    this.marketService.search(null, "activeVersion.createdDate", "desc", 0, 5).subscribe((products: any) => {
      this.products = products.content.map((product: any) => product.activeVersion);
      this.products.forEach((product: any) => {
        this.imageQueue.push(product);
        if (product.imagePath) {
          this.marketService.downloadIcon(product.id).subscribe(image => {
            this.setImage(product, image);
          });
        } else if (product.catalog.catalog) {
          this.marketService.loadCatalogIcon(product.catalog.catalog.id, product.catalog.id).subscribe((image: any) => {
            this.setImage(product, image);
          });
        } else {
          this.marketService.loadCatalogVersionIcon(product.catalog.catalogVersionId).subscribe((image: any) => {
            this.setImage(product, image);
          });
        }
      });
      if (this.products && this.products.length > 0) {
        this.activeIndex = 0;
        this.activeProduct = this.products[this.activeIndex];
      } else {
        this.activeProduct = null;
      }
    });
  }

  setImage(product: any, image: any) {
    if (image) {
      if (image.size !== 0) {
        const reader = new FileReader();
        const self = this;

        reader.onload = () => {
          product.imageFileSource = reader.result;
          if (product.imageFileSource && product.imageFileSource.indexOf('png') !== -1) {
            product.imageFileSource = this.sanitizer.bypassSecurityTrustUrl(product.imageFileSource);
          }
        };
        reader.onerror = () => {
          product.imageFileSource = this.getDefaultImageUrl();
        };
        reader.readAsDataURL(image);
      } else {
        product.imageFileSource = this.getDefaultImageUrl();
      }
    }
  }

  handleError(product: any) {
    product.imageFileSource = this.getDefaultImageUrl();
  }

	getDefaultImageUrl() {
    return 'assets/images/serengeti-market/card/default/edit.png';
	}

  onClick(product: any) {
  }

  doChangeActive(productIndex: number) {
    this.activeIndex = productIndex;
    this.activeProduct = this.products[this.activeIndex];
  }

}
